<template>
  <v-container fluid class="pa-2">

    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    
    
    <!-- EVENT ITEMS -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!isLoading">
      
      <template v-for="item in events">
        <div class="col-12 col-sm-6 col-lg-3 ma-0 pa-2" :key="item.identifier">
          <v-card
              height="100%"
              link
              class="rounded-lg d-flex flex-column"
              @click.prevent="openItem(item)"
          >
            <v-img
                v-if="item.thumbnail"
                :src="item.thumbnail"
            ></v-img>
            <v-card-title class="text-break"><strong>{{ item.title }}</strong></v-card-title>
<!--            <v-card-subtitle>{{ $moment(item.from).format("DD/MM/YYYY") }} - {{ $moment(item.until).format("DD/MM/YYYY") }}</v-card-subtitle>-->
            <v-card-text class="fill-height">
              <div v-if="item.shortDescription" v-html="item.shortDescription"></div>
            </v-card-text>
          </v-card>
        </div>
      </template>

    </div>


    <!-- EVENT DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="selectedItem.image"
            :src="selectedItem.image"
            max-height="400"
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-title v-if="selectedItem.title" class="text-break"><strong>{{ selectedItem.title }}</strong></v-card-title>
<!--        <v-card-subtitle>{{ $moment(selectedItem.from).format("DD/MM/YYYY") }} - {{ $moment(selectedItem.until).format("DD/MM/YYYY") }}</v-card-subtitle>-->
        <v-card-text class="fill-height">
          <div v-if="selectedItem.description" v-html="selectedItem.description"></div>
        </v-card-text>
          <v-divider v-if="selectedItem.url || selectedItem.registrationModule"></v-divider>
          <v-card-actions class="justify-end mt-auto" v-if="selectedItem.url || selectedItem.registrationModule">
              <template v-if="selectedItem.registrationModule">
                  <template v-if="!selectedItem.registrationModule.registered">
                      <v-btn
                              color="primary"
                              depressed
                              class="rounded-lg"
                              :loading="registrationLoading"
                              :disabled="!(selectedItem.registrationModule.registerCount < selectedItem.registrationModule.maxParticipants) || !$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                              @click.prevent="checkConsentAndRegisterForEvent()"
                      >
                          {{ $t('buttons.register') }}
                      </v-btn>
                  </template>
                  <template v-if="selectedItem.registrationModule.registered">
                      <v-btn
                              color="primary"
                              depressed
                              class="rounded-lg"
                              :loading="registrationLoading"
                              :disabled="!$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                              @click.prevent="deleteRegistrationForEvent()"
                      >
                          {{ $t('buttons.deregister') }}
                      </v-btn>
                  </template>
              </template>
              <template v-else-if="selectedItem.url">
                  <v-btn
                          color="primary"
                          depressed
                          class="rounded-lg"
                          @click.prevent="navigate(selectedItem.url)"
                  >
                      {{ $t('buttons.participate') }}
                  </v-btn>
              </template>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CONSENT DIALOG -->
    <m2h-consent-dialog></m2h-consent-dialog>
    
  </v-container>
</template>

<script>

import api from "@/api/api";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "m2h-events",
  data() {
    return {
      isLoading: true,
      events: [],
      showItemDialog: false,
      selectedItem: {},
      registrationLoading: false,
      acceptConsent: false,
      consent: {},
      handleConsentLoading: false,
      consentDialogIdentifier: ''
    }
  },

  mounted(){
    this.fetchEvents()
    this.$root.$on('handle-consent-dialog', (data) => {
      if (data.consentDialogIdentifier === this.consentDialogIdentifier){
        this.registerForEvent()
      }
    })
  },

  methods: {
    async fetchEvents(){
      this.isLoading = true
      let events = []
      events = await api.newsItems.getList("event", this.$i18n.locale).then((res) => { return res.data })
      if (events.length){
        this.events = events.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        for (const item of this.events) {
          let image = await this.fetchImage(item.imageAssetId)
          let thumbnail = await this.fetchImage(item.thumbnailAssetId)
          item.image = image
          item.thumbnail = thumbnail
        }
      }
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    },
    
    async openItem(item){
      this.selectedItem = item
      if (item.registrationModule && item.registrationModule.identifier){
          this.selectedItem.registrationModule.registered = await api.userRegistrations.getRegistrationExists(item.registrationModule.identifier).then((res) => {
              return res.data
          })
          await this.updateRegisterCount()
      }
      this.showItemDialog = true
      this.$root.$emit('post-event-opened', { id: item.identifier })
    },

    async registerForEvent(){
        this.registrationLoading = true
        await this.updateRegisterCount()
        if (this.selectedItem.registrationModule.registerCount < this.selectedItem.registrationModule.maxParticipants){
            let registration = await api.userRegistrations.postRegistrationRegister(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
            if (registration.identifier){
                this.selectedItem.registrationModule.registered = true
                await this.updateRegisterCount()
                this.$root.$emit('open-snackbar', { mode: "registered", title: this.selectedItem.title })
            }
        }
        this.registrationLoading = false
    },

    async updateRegisterCount(){
        this.selectedItem.registrationModule.registerCount = await api.userRegistrations.getRegistrationCount(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
    },

    async deleteRegistrationForEvent(){
        this.registrationLoading = true
        let registration = await api.userRegistrations.getRegistration(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
        if (registration.identifier){
            await api.userRegistrations.deleteRegistration(registration.identifier)
            this.selectedItem.registrationModule.registered = false
            this.$root.$emit('open-snackbar', { mode: "deregistered", title: this.selectedItem.title })
        }
        await this.updateRegisterCount()
        this.registrationLoading = false
    },
      
    async checkConsent(){
        this.consent = await api.consent.getForLabel(this.selectedItem.registrationModule.consentLabel).then((res) => { return res.data })
        this.acceptConsent = this.consent.approved
    },

    async checkConsentAndRegisterForEvent(){
        this.registrationLoading = true
        await this.checkConsent()
        if (this.acceptConsent){
            await this.registerForEvent()
        } else {
          this.consentDialogIdentifier = uuidv4();
          this.$root.$emit('open-consent-dialog', { consentDialogIdentifier: this.consentDialogIdentifier, consentLabel: this.selectedItem.registrationModule.consentLabel })
        }
        this.registrationLoading = false
    },

    navigate(route){
      //window.location.href = route
      if (route){
        window.open(route, '_blank');
      }
    },
  }
}
</script>

<style scoped>

</style>
